export const getChromaticProps = (chromaticIgnore: boolean | undefined) => {
  if (!chromaticIgnore) return undefined

  return {
    "data-chromatic": "ignore",
  }
}
